import { observer } from 'mobx-react-lite';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Button } from '~/components/isolated/Button';
import { IconButton } from '~/components/isolated/IconButton';
import Modal from '~/components/Modal/Modal';
import { useGlobal } from '~/hooks/useGlobal';

import { cartStore } from '~/stores';

import { StockProductCard } from './components/StockProductCard';
import styles from './ModalStockChangedV3.module.scss';

const ModalStockChangedV3 = () => {
  const { t } = useTranslation();
  const { isMobile, isSSR } = useGlobal();
  const { pathname } = useLocation();
  const { cartStockChangesStore } = cartStore;

  const handleClose = () => {
    cartStockChangesStore.updateCartAndCloseNotifierModal();
  };

  const isOpen =
    cartStockChangesStore.isOpen && ['/cart', '/checkout'].includes(pathname);

  const modal = (
    <Modal isShow={isOpen} className={styles.root} onBackdropDismiss={noop}>
      <div className={styles.head}>
        <h3 className={styles.title}>{t('phrases:availableStockChanged')}</h3>
        {!isMobile && (
          <div>
            <IconButton size="S" icon="close" onClick={handleClose} />
          </div>
        )}
      </div>
      <div className={styles.body}>
        <div className={styles.productGrid}>
          {cartStockChangesStore.unavailableCartItems.map((item) => (
            <StockProductCard
              key={item.cartItem.id}
              product={item.cartItem}
              stockInfo={item.error}
              bundleStockInfo={item.bundleError}
            />
          ))}
        </div>
      </div>
      <div className={styles.footer}>
        <Button onClick={handleClose} size="XL" className={styles.okBtn}>
          {isMobile ? t('gotItButton') : t('ok')}
        </Button>
      </div>
    </Modal>
  );

  if (isSSR || !isOpen) {
    return null;
  }

  return createPortal(modal, document.body);
};

const noop = () => void 0;

export default observer(ModalStockChangedV3);
